export const selectDraftChatMessage = state => state.chat.draftChatMessage;
export const selectMessages = state => state.chat.messages;
export const selectIsWaitingForChatResponse = state => state.chat.isWaitingForResponse;
export const selectChatFetchStatus = state => state.chat.status;
export const selectChatOffset = state => state.chat.offset;
export const selectPagingStatus = state => state.chat.pagingStatus;
export const selectActiveThreadId = state => state.chat.threadId;
export const selectBoxId = state => state.chat.knowledgeBoxId;
export const selectHasMore = state => state.chat.hasMore;
export const selectLastUserMessage = state => state.chat.lastUserMessage;
export const selectIsCurrentThreadAutocreated = state => state.chat.isCurrentThreadAutocreated;
export const selectShouldPollCsatSurvey = state => state.chat.shouldPollCsatSurvey;
export const selectShowCsatSurvey = state => state.chat.showCsatSurvey;
export const selectIsCreatingThread = state => state.chat.isCreatingThread;
export const selectAblyChannelId = state => state.chat.ablyChannelId;
export const selectChannelConnectingStatus = state => state.chat.channelConnectingState;
export const selectIsSavedPrompt = state => state.chat.isSavedPrompt;
export const selectFailedUserMessages = state => state.chat.failedUserMessages;
export const selectIsStreamingWithReasoningTimestamp = state => state.chat.isStreamingWithReasoningTimestamp;
export const selectCopilotV2ResponseStatus = state => state.chat.copilotV2ResponseStatus;